<template>
<transition 
  appear
  @before-enter="beforeEnter"
	@enter="enter"
	@after-enter="afterEnter"
  @before-leave="beforeLeave"
	@leave="leave"
	@after-leave="afterLeave"
  >
<dialog v-if="showModal" class="c-modal" :class="{'c-modal--function': isFunction, 'c-modal--photo-h': !isPhotoVertical, 'c-modal--photo-v': isPhotoVertical}">
  <!-- wrap -->
  <div ref="swiper-sp" class="c-modal__wrap swiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide">
        <!-- function -->
        <div v-if="isFunction" class="c-function">
          <div class="c-function__photo">
            <div class="is-wrap">
              <h3 v-if="modalData.function > 0">FUNCTION {{fNumber}}</h3>
              <span><img :src="modalData.photo.src" alt="" /></span>
            </div>
          </div>
          <div class="c-function__items">
            <div ref="swiper-pc" class="swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="c-pickup">
                    <div class="c-pickup__photo">
                      <img :src="modalData.pickup.src" alt="" />
                    </div>
                    <dl class="c-pickup__title">
                      <dt v-if="modalData.pickup.name" v-html="modalData.pickup.name"></dt>
                      <dd v-for="item in modalData.pickup.items">
                        <a v-if="item.url" class="is-name" :href="item.url" target="_blank" v-html="item.title"></a>
                        <span v-if="!item.url" class="is-name" v-html="item.title"></span>
                        <span class="is-price">{{item.price}}</span>
                      </dd>
                    </dl>
                    <ul class="c-pickup__feature">
                      <li v-for="ft in modalData.pickup.feature" :key="ft">
                        <div class="c-feature">
                          <div class="c-feature__photo">
                            <img :src="ft.src" alt="" />
                          </div>
                          <div class="c-feature__info">
                            <h4>【{{ft.title}}】</h4>
                            <p v-html="ft.text"></p>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div class="c-pickup__items">
                      <dl class="c-list">
                        <dd v-for="item in modalData.list" :key="item">
                          <a v-if="item.url" class="is-name" :href="item.url" target="_blank" v-html="item.title"></a>
                          <span v-if="!item.url" class="is-name" v-html="item.title"></span>
                          <span class="is-price">¥{{item.price}}</span>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-scrollbar--pc"></div>
            </div>
          </div>
        </div>
        <!-- /function -->
        <!-- text -->
        <div v-if="!isFunction" class="c-detail">
          <div class="c-detail__photo">
            <span><img :src="modalData.photo.src" alt="" /></span>
          </div>
          <div class="c-detail__items">
            <div ref="swiper-pc" class="swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <dl class="c-list" v-for="list in modalData.list" :key="list">
                    <dt v-html="list.title"></dt>
                    <dd v-for="item in list.item" :key="item">
                      <a v-if="item.url" class="is-name" :href="item.url" target="_blank" v-html="item.title"></a>
                      <span v-if="!item.url" class="is-name" v-html="item.title"></span>
                      <span class="is-price">¥{{item.price}}</span>
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="swiper-scrollbar--pc"></div>
            </div>
          </div>
        </div>
        <!-- text -->
      </div>
    </div>
    <div class="swiper-scrollbar--sp"></div>
  </div>
  <!-- /wrap -->
  <div class="c-modal__close" @click="closeModal">
    <button class="c-btnClose">
      <span></span>
    </button>
  </div>
</dialog>
</transition>
</template>

<script>
import {gsap, Power3, Expo} from 'gsap/all';
import Swiper, {FreeMode, Scrollbar, Mousewheel} from 'swiper';

export default {
  data() {
    return { 
      isFunction: false,
      isPhotoVertical: false,
      oSwiper: null,
      pastScrollY: 0,
      diff: 0,
      preWidth: 0,
    }
  },
  computed: {
    fNumber() {
      if (this.isFunction > 0) {
        if (this.modalData.function < 10) {
          return '0' + this.modalData.function;
        } else {
          return this.modalData.function;
        }
      }
    },
    modalData() {
      return this.$store.getters.currentModal;
    },
    showModal() {
      return this.$store.getters.showModal;
    },
  },
  watch: {
    modalData (newData, oldData) {
      if (newData.function === -1 || newData.function) {
        this.isFunction = true;
      } else {
        this.isFunction = false;
      }
    },
    showModal (isShow, isOld) {
      if (isShow) {
        this.openModal();
      } else {
        this.modalData = null;
      }
    },
  },
  mounted() {
    
  },
  methods: {
    oncePC() {
      this.oSwiper = new Swiper(this.$refs['swiper-pc'], {
        modules: [FreeMode, Scrollbar, Mousewheel],
        speed: 600,
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
        scrollbar: {
          el: '.swiper-scrollbar--pc',
          draggable: true,
          hide: false,
          dragSize: 'auto',
        },
        on: {
          lock: function(e) {
            // console.log('lock', e);
            e.$el[0].classList.add('swiper--center');
            e.$el[0].classList.remove('swiper--masked-overflow');
          },
          unlock: function(e) {
            // console.log('unlock', e);
            e.$el[0].classList.remove('swiper--center');
            e.$el[0].classList.add('swiper--masked-overflow');
          },
        }
      });

      // this.resize();
    },
    onceSP() {
      this.oSwiper = new Swiper(this.$refs['swiper-sp'], {
        modules: [FreeMode, Scrollbar, Mousewheel],
        speed: 600,
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
        scrollbar: {
          el: '.swiper-scrollbar--sp',
          draggable: true,
          hide: false,
          dragSize: 'auto',
        },
        on: {
          lock: function(e) {
            // console.log('lock', e);
            e.$el[0].classList.add('swiper--center');
            e.$el[0].classList.remove('swiper--masked-overflow');
          },
          unlock: function(e) {
            // console.log('unlock', e);
            e.$el[0].classList.remove('swiper--center');
            e.$el[0].classList.add('swiper--masked-overflow');
          },
        }
      });

      // this.resize();
    },
    destroy() {
      if (this.oSwiper) this.oSwiper.destroy(false, true);
    },
    openModal() {
      const img = new Image();
      img.onload = () => {
        this.loaded({width: img.width, height: img.height});
      }
      img.src = this.modalData.photo.src;

      window.addEventListener('resize', this.resize);
      this.$nextTick(this.resize);

      if (this.$store.getters.ScrollSmoother) {
        this.$store.getters.ScrollSmoother.paused(true);
      } else {
        // this.pastScrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;
        const body = document.body;
        // body.style.position = 'fixed';
        body.style.overflow = 'hidden';
        window.gPG.rootHTML.style.overflow = 'hidden';
      }
    },
    closeModal() {
      window.removeEventListener('resize', this.resize);
      this.destroy();
      this.$store.commit('setShowModal', false);

      if (this.$store.getters.ScrollSmoother) {
        this.$store.getters.ScrollSmoother.paused(false);
      } else {
        const body = document.body;
        // body.style.position = '';
        body.style.overflow = '';
        window.gPG.rootHTML.style.overflow = '';
        // window.scrollTo(0, this.pastScrollY);
      }
    },
    showBefore(el) {
      const wrap = el.querySelector('.swiper');
      const scroller = wrap.querySelector('.swiper-wrapper');
      const scrollbar = wrap.querySelector('.swiper-scrollbar');
      this.diff = scroller.scrollHeight - wrap.getBoundingClientRect().height;

      if (this.diff > 0) {
        gsap.set(scroller, {
          y: -this.diff,
          opacity: 0,
        });

        gsap.set(scrollbar, {
          opacity: 0,
          y: 100,
        });
      }
    },
    show() {
      const wrap = this.$el.querySelector('.swiper');
      const scroller = wrap.querySelector('.swiper-wrapper');
      const scrollbar = wrap.querySelector('.swiper-scrollbar');

      gsap.to(scroller, {
        duration: 1.2,
        y: 0,
        ease: Expo.easeInOut,
      });

      gsap.to(scroller, {
        delay: 0.1,
        duration: 1.2,
        opacity: 1,
        clearProps: 'all',
        ease: Expo.easeOut,
      })

      gsap.to(scrollbar, {
        delay: 0.6,
        duration: 1.0,
        opacity: 1,
        y: 0,
        clearProps: 'all',
        ease: Expo.easeOut,
      });
    },
    loaded(e) {
      if (e.width > e.height) {
        this.isPhotoVertical = false;
      } else {
        this.isPhotoVertical = true;
      }
    },
    resize() {
      // if (!this.oSwiper) return;
      // if (this.getMatchMedia(1000)) { 
      //   this.oSwiper.disable();
      // } else {
      //   this.oSwiper.enable();
      // }
      if (this.getMatchMedia(1000)) {
        this.destroy();
        this.onceSP();
      } else {
        this.destroy();
        this.oncePC();
      }

      this.preWidth = window.innerWidth;
    },
    getMatchMedia(width) {
      return window.matchMedia('(max-width: ' + width +'px)').matches;
    },
    // vue transition
    beforeEnter() {
    },
    enter(el, done) {
      // this.showBefore(el);

      gsap.fromTo(el, {
        'clip-path': 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
      }, {
        duration: 1.0,
        'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        ease: Expo.easeInOut,
        onComplete: done,
      });
    },
    afterEnter() {
      // this.show();
    },
    beforeLeave() {
    },
    leave(el, done) {
      gsap.to(el, {
        duration: 1.0,
        'clip-path': 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
        ease: Expo.easeInOut,
        onComplete: done,
      });
    },
    afterLeave() {
      // console.log('afterLeave');
    },
  }
}
</script>